import axios from '@/lib/axios';
import { MonthlyOrderingBudget, MonthlySalesTarget, UserInvitation, Workspace } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0360. チーム月間発注予算登録
 * [POST] /workspaces/:identifier/teams/:team_id/monthly_ordering_budgets
 */
type Props = {
  identifier: string;
  team_id: number;
  year_month: number;
  amount: number;
};
const createMonthlyOrderingBudgets = (props: Props): Promise<MonthlyOrderingBudget> => {
  return axios.post(`/api/workspaces/${props.identifier}/teams/${props.team_id}/monthly_ordering_budgets`, props);
};

export const useCreateMonthlyOrderingBudgets = () => {
  return useMutation({
    mutationFn: createMonthlyOrderingBudgets,
  });
};
